var Modal = require("components/utility/AltModal");

require("games/purchase_modal.scss");

class PurchaseModal extends React.Component {

    constructor(props) {
        super();
        autobind(this);
    }

    show() {
        this.props.checkConfirm(true)
        this.refs.modal.show();
    }

    hide() {
        this.props.checkConfirm(false)
        this.refs.modal.hide();
    }

    renderControls() {
        return (
            <div className="controls">
                <button className="btn buttonSuccess" onClick={this.props.onPurchase}>
                    Buy
                </button>
                <a href="#" onClick={this.hide}> Cancel </a>
            </div>
        );
    }

    render() {
        var item = this.props.previewItem
        if (this.props.isPatch) {
            var displayItem = this.props.renderPatchItem(item);
        } else {
            var displayItem = this.props.renderPerkItem(item);
        }

        var controls = this.renderControls()
        var title = "Confirm Purchase"
        return (
            <Modal ref="modal" className="purchaseModal" headerText={title}>
                <div className="modalItem">
                    {displayItem}
                </div>
                <div className="modalItem">
                    {controls}
                </div>
            </Modal>
        );
    }
}

module.exports = PurchaseModal;


// WEBPACK FOOTER //
// ./modules/components/games/PurchaseModal.js